import http, { url } from '../../http'

const API_URL = "hygiene_service"

class serviciosHigieneAPI {

  async save(highdirection) {
    const response = await http(`${API_URL}/save`, 'POST', highdirection)
    return response
  }
 
  async getAllIdentification() {
    const response = await http(`${API_URL}`)
    return response
  } 

  async getActa() {
    return url(`highdirection`)
  } 

  async getAllIdentificationCompany(id,  page) {
    const response = await http(`${API_URL}/company/${id}?page=${page}`)
    return response
  } 
 
  async getPolitica(id) {
    const response = await http(`${API_URL}/index/${id}`)
    return response
  }

  async getShow(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  }

  async getAll(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async get(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  }

  async update(id, revision) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', revision)
    return response
  }
  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

 
  
}

export default new serviciosHigieneAPI()